module.exports = "https://static.wanderu.com/ui-react/_next/static/media/tech-crunch.82a5cb7b.png";